import { useEffect } from 'react';

import { useCurrentRoleTaxonomyVersion } from '../../../../../shared/selection-lists/hooks/useRoleTaxonomyAdapter';
import { useCurrentSkillTaxonomyVersion } from '../../../../../shared/selection-lists/hooks/useSkillTaxonomyAdapter';
import { useFilterContext } from '../../../filters/contexts/FilterProvider';
import { createNonPrimaryParameterFilterMap } from '../../../filters/utils/createNonPrimaryParameterFilterMap';
import type { ReportParameterConfig } from '../../PageConfigProvider/page-reducer';

export const useAddParameterFilterGroup = ({
  parameters,
}: {
  parameters: ReportParameterConfig[];
}) => {
  const { filterState, dispatch: filterDispatch } = useFilterContext();
  const { version: roleTaxonomyVersion } = useCurrentRoleTaxonomyVersion();
  const { version: skillTaxonomyVersion } = useCurrentSkillTaxonomyVersion();

  useEffect(() => {
    // if there are multiple additional parameters, set them as additional filterMaps
    const additionalParameterIds = parameters
      .slice(1)
      .map((p) => p.parameterId);
    if (additionalParameterIds.length < 1) return;

    const groupMap = filterState?.groupMap;
    const groupMapKeys = Array.from(groupMap?.keys() ?? []);
    const parametersNotInGroupMap = additionalParameterIds.filter(
      (id) => !groupMapKeys.includes(id)
    );
    if (parametersNotInGroupMap.length < 1) return;

    parametersNotInGroupMap.forEach((id) => {
      const newFilterMap = createNonPrimaryParameterFilterMap({
        roleTaxonomyVersion,
        skillTaxonomyVersion,
      });
      filterDispatch({
        type: 'ADD_NEW_FILTER_GROUP',
        payload: { newFilterKey: id, newFilterMap },
      });
    });
  }, [
    filterState?.groupMap,
    parameters,
    roleTaxonomyVersion,
    skillTaxonomyVersion,
    filterDispatch,
  ]);
};
